import React, { FC } from 'react'
import { GridColDef } from '@mui/x-data-grid-premium'
import { SensorColumnsDataGrid } from 'src/components/columns/sensor'
import { Sensor, SensorState } from 'src/api'
import { SensorsMapView } from 'src/components/ui'
import { SearchParamsKeys, ViewTypes, SensorFilters, SensorButtons } from 'src/enums'
import { useQueryParamsState } from 'src/hooks/ui'
import { SensorListFilters } from 'src/components/forms/sensor'
import { CommonSensorList } from './commonSensorsList'
import { ContractorsDataLoader } from './contractorsDataLoader'
import { SensorContextMenu, SensorMenuItemKey, useSensorContextMenu, createActionsColumn } from './sensorContextMenu'
import { SensorMapFilters } from '../../../forms/sensor/sensorMapFilters'

interface AvailableSensorListProps {
  isLoading: boolean
  count: number
  data: Sensor[]
  states: SensorState[]
  refetchSensorList: () => void
}

export const AvailableSensorList: FC<AvailableSensorListProps> = ({ data, isLoading, count, states, refetchSensorList }) => {
  const { currentRow, menuAnchorEl, handleOpenMenu, handleCloseMenu } = useSensorContextMenu()
  const queryParams = useQueryParamsState()
  const viewType = queryParams[SearchParamsKeys.ViewType] || ViewTypes.List

  const columns: GridColDef<Sensor>[] = [
    SensorColumnsDataGrid.Id(),
    SensorColumnsDataGrid.Model,
    SensorColumnsDataGrid.IMEI,
    SensorColumnsDataGrid.DevEUI,
    SensorColumnsDataGrid.LastPing,
    SensorColumnsDataGrid.BatteryLevel,
    SensorColumnsDataGrid.DateAdded,
    SensorColumnsDataGrid.Description,
    SensorColumnsDataGrid.StateUpdatedAt,
    SensorColumnsDataGrid.StateAuthor,
    SensorColumnsDataGrid.OrderDate,
    SensorColumnsDataGrid.OrderNumber,
    SensorColumnsDataGrid.OrderPart,
    createActionsColumn(handleOpenMenu)
  ]

  return (
    <>
      {viewType === ViewTypes.List ? (
        <>
          <CommonSensorList
            columns={columns}
            count={count}
            data={data}
            isLoading={isLoading}
            filters={
              <SensorListFilters
                activeFilters={[
                  SensorFilters.LowBattery,
                  SensorFilters.WeakSignal,
                  SensorFilters.LastPingMoreThanHour,
                  SensorFilters.SyncPeriod,
                  SensorFilters.ReadingsAge,
                  SensorFilters.CurrentSensorConfiguration,
                  SensorFilters.BleStatus,
                  SensorFilters.OrderNumber,
                  SensorFilters.OrderDate
                ]}
              />
            }
            buttons={[SensorButtons.QualityControl, SensorButtons.DownloadLabels, SensorButtons.Assign]}
            checkboxSelection
          />
          <SensorContextMenu
            menuItems={[SensorMenuItemKey.Assign, SensorMenuItemKey.MarkAsLost]}
            qualityControlBeforeAssign
            currentRow={currentRow}
            menuAnchorEl={menuAnchorEl}
            onOpenMenu={handleOpenMenu}
            onCloseMenu={handleCloseMenu}
            states={states}
            refetchSensorList={refetchSensorList}
          />
        </>
      ) : (
        <SensorsMapView
          data={data}
          isLoading={isLoading}
          filters={
            <ContractorsDataLoader>
              <SensorMapFilters
                activeFilters={[
                  SensorFilters.Contractor,
                  SensorFilters.LowBattery,
                  SensorFilters.WeakSignal,
                  SensorFilters.LastPingMoreThanHour,
                  SensorFilters.SyncPeriod,
                  SensorFilters.ReadingsAge,
                  SensorFilters.LocationType,
                  SensorFilters.OrderNumber,
                  SensorFilters.OrderDate
                ]}
              />
            </ContractorsDataLoader>
          }
        />
      )}
    </>
  )
}
